import { getUserInfo } from "appredux/actions/showActions";
import { selectUserInfo, selectUserInfoLoading } from "appredux/user/userSlice";
import { analytics } from "lib/segment";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

const PrivateRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const isAuthenticated = localStorage.getItem("auth") !== null;
  const location = useLocation();
  const dispatch = useDispatch();
  const userInfoLoading = useSelector(selectUserInfoLoading);
  const userInfo = useSelector(selectUserInfo);

  useEffect(() => {
    if (userInfoLoading !== "succeeded") {
      // @ts-ignore
      dispatch(getUserInfo(localStorage.getItem("farm")));
    }
  }, []);

  useEffect(() => {
    if (userInfoLoading === "succeeded") {
      analytics.identify(String(userInfo.email), {
        firstname: userInfo.firstname,
        lastname: userInfo.lastname,
        email: userInfo.email,
        farmcode: userInfo.farmcode,
      });

      if (!userInfo.usefId) {
        analytics.track("Not Linked USEF Account", {
          email: userInfo.email,
        });
      } else {
        analytics.track("Linked USEF Account", {
          email: userInfo.email,
        });
      }

      try {
        // @ts-ignore
        window.heap?.identify?.(String(userInfo.email));
      } catch (error) {
        console.error(error);
      }
    }
  }, [userInfoLoading]);

  return !isAuthenticated ? (
    <Navigate to={"/authentication/sign-in/cover"} state={{ from: location }} replace />
  ) : (
    children
  );
};

export default PrivateRoute;
